/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import i18n from '@/i18n';
import { GlobalResponseType } from '@/features/common/types';

const getFormattedErrorObj = (
  errorMessage?: string,
  fallBackMessage = i18n.t('alertDialog.somethingWentWrong'),
) => ({
  successful: false,
  errorMessage: errorMessage || fallBackMessage as string,
  redirectUrl: '',
  isCarrierMessage: false,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseError = (error: any): GlobalResponseType => {
  if (!error.response) return getFormattedErrorObj();

  const {
    status, detail, nestedException, errors,
  } = error.response.data || {};

  if (status === 500 && nestedException) {
    if (nestedException.detail) {
      return getFormattedErrorObj(nestedException.detail);
    }

    const nestedErrors = nestedException.errors;
    const nestedErrorKeys = nestedErrors ? Object.keys(nestedErrors) : [];

    if (nestedErrorKeys.length > 0) {
      const errorMessage = nestedErrors[nestedErrorKeys[0]][0];
      return getFormattedErrorObj(errorMessage);
    }
  }

  if (status === 400) {
    if (errors) {
      const errorKeys = Object.keys(errors);
      if (errorKeys.length > 0) {
        const firstFieldErrors = errors[errorKeys[0]];
        let errorMessage: string | undefined;
        if (Array.isArray(firstFieldErrors)) {
          // eslint-disable-next-line prefer-destructuring
          errorMessage = firstFieldErrors[0];
        } else if (typeof firstFieldErrors === 'string') {
          errorMessage = firstFieldErrors;
        }
        if (errorMessage) return getFormattedErrorObj(errorMessage);
      }
    }
    if (typeof detail === 'string' && detail) {
      return getFormattedErrorObj(detail);
    }
    if (error.response.data?.title && error.response.data.title !== 'One or more validation errors occurred.') {
      return getFormattedErrorObj(error.response.data.title);
    }
  }

  if (status === 403) {
    return getFormattedErrorObj(detail, i18n.t('alertDialog.forbidden'));
  }

  if (status !== 422 || !detail) {
    return getFormattedErrorObj();
  }

  try {
    const errDetail = JSON.parse(detail);
    return {
      successful: false,
      errorMessage: errDetail.message,
      redirectUrl: errDetail.redirectUrl || '',
      errorType: errDetail.type,
      isCarrierMessage: false,
    };
  } catch {
    return {
      successful: false,
      errorMessage: detail,
      redirectUrl: '',
      errorType: error.response.data?.title,
      isCarrierMessage: false,
    };
  }
};

export const filterExceptionMessage = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any,
  messageKey: string,
): GlobalResponseType => {
  const errResponse = parseError(error);
  if (!errResponse.errorType) return errResponse;

  if (!i18n.te(messageKey)) return errResponse;

  return {
    ...errResponse,
    errorMessage: i18n.t(messageKey) as string,
  };
};
